import { useState } from "react";
import MonitorIcon from "@assets/svg/MonitorIcon";
import NotepadIcon from "@assets/svg/NotepadIcon";
import NotebookIcon from "@assets/svg/NotebookIcon";
import CheckSquareIcon from "@assets/svg/CheckSquareIcon";
import { useSearchParams } from "react-router-dom";
import ViewByJob from "./components/ViewByJob";
import ViewByCandidate from "./components/ViewByCandidate";
import PlusCircleIcon from "@assets/svg/PlusCircleIcon";
import { NavLink } from "react-router-dom";

const stats = [
  {
    label: "Interviewing",
    value: 5,
    icon: <MonitorIcon />,
  },
  {
    label: "Viewed",
    value: 23,
    icon: <NotepadIcon />,
  },
  {
    label: "Submitted",
    value: 7,
    icon: <NotebookIcon />,
  },
  {
    label: "Applied",
    value: 12,
    icon: <CheckSquareIcon />,
  },
];

const tabs = [
  {
    label: "View by Job",
    value: "byJob",
  },
  {
    label: "View by Candidate",
    value: "byCandidate",
  },
];

const JobPageLayout = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabView = searchParams.get("tabView");
  // Local states
  const [activeTab, setActiveTab] = useState("byJob");

  const handleClick = (value: string) => {
    setSearchParams({ tabView: value });
  };

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow p-4 min-h-0">
      {/* Top container */}
      <div className="flex items-center justify-between mb-10">
        {/* Col 1 */}
        <div className="w-[40%] flex flex-col gap-4">
          <div className="flex bg-light-white-700 rounded-md p-2.5">
            {tabs?.map((tab) => {
              const isSelected = activeTab === tab?.value;
              return (
                <button
                  key={tab?.value}
                  onClick={() => setActiveTab(tab?.value)}
                  className={`${
                    isSelected
                      ? "bg-white shadow-[1px_1px_12px_rgba(0,0,0,0.08)]"
                      : ""
                  } rounded-md h-6 flex-1 font-semibold text-xs text-primary `}
                >
                  {tab?.label}
                </button>
              );
            })}
          </div>
          {/* Search section */}
          <div className="flex items-center gap-4">
            <div className="bg-light-white-700 rounded-md p-1.5 flex-1">
              <input
                className="bg-white rounded-md text-xs h-8 px-3 font-medium w-full outline-none"
                placeholder="Search"
              />
            </div>
            <button className="bg-light-white-700 h-11 px-5 text-xs rounded-md flex items-center justify-center font-semibold text-primary hover:bg-gray-200">
              Filter
            </button>
          </div>
        </div>
        <NavLink
        to={'/job/create'}
        className="bg-primary rounded-md flex items-center justify-center text-white text-xs font-semibold py-2 px-3 hover:bg-black gap-1">
          <PlusCircleIcon fill="white"/>
          Create Job
        </NavLink>
        {/* Col 2 */}
        <div className="w-[40%] grid grid-cols-2 gap-2.5">
          {stats?.map((stat) => {
            return (
              <div
                key={stat?.label}
                className="flex items-center gap-2 bg-light-white-700 rounded-md p-2.5"
              >
                <div className="flex items-center justify-center bg-white rounded-md h-7 w-7">
                  {stat?.icon}
                </div>
                <span className="font-semibold text-xs ">
                  {stat?.label} :&nbsp; {stat?.value}
                </span>
              </div>
            );
          })}
        </div>
      </div>
      {/* List container */}
      {activeTab === "byJob" ? <ViewByJob /> : <ViewByCandidate />}
    </div>
  );
};

export default JobPageLayout;
